<template>
  <div class="d-flex flex-column" dir="rtl">
    <div class="dflex dflex-row">
      <!-- <div class="f20-l20 pointer" @click="$emit('close')">X</div> -->
      <div v-if="wizard.steps.length > 1"  class="text-center f14-l17 df28-l40-l">{{activeStep+1}}/{{wizard.steps.length}}</div>
      </div>
    <form class="formfield-round-border" :method="formMethod" ref="form" :action="wizard.steps[wizard.steps.length-1].submit.href">
      <div v-for="(step,idx) in wizard.steps" :key="idx" :ref="`step` + idx" v-show="idx==activeStep" class="margin-top-20">
        <div class="d-flex flex-column">
          <div class="d-flex flex-row">
            <div v-if="idx>0 && !step.skip?.hide" class="f20-l20-b red pointer" @click="wizardSkip(-1)">&lt;</div>
            <div v-if="step.title"  class="text-center f20-l20-b df30-l30-b flex-grow-1">{{step.title}}</div>
            <SvgImage v-if="step.icon" :src="step.icon.src" style="height: 130px;" class="margin-top-5 mx-auto align-self-center" />
            <div v-if="step.skip" class="f16-l10 red pointer" @click="wizardSkip(1)">{{step.skip.label}}</div>
          </div>
          <div class="text-center f14-l17 margin-top-10" v-html="step.description"></div>
          <div class="margin-top-20"></div>
          <div v-if="step.form">
            <FormFieldComponent  v-for="(field,idx2) in step.form.fields" :key="idx2" :field="field" class="formfield-round-border" />
          </div>
        </div>
        <ButtonComponent v-if="step.next" :caption="step.next.label" @click="wizardSkip(1)" @keyup.enter="wizardSkip(1)" class="margin-top-20" />
        <ButtonComponent v-if="step.submit && !step.submit.hide" :caption="step.submit.label" @click="onSubmit()" @keyup.enter="onSubmit()" class="margin-top-20" />
        <ButtonComponent v-if="step.cancel" :caption="step.cancel.label" @click="$emit('close')" class="margin-top-20" />
      </div>
    </form>
  </div>
</template>
<script>
import {formSubmit} from '@/modules/configuration.js'
import FormFieldComponent from "@/components/form/FormFieldComponent";
import ButtonComponent from "@/components/form/ButtonComponent"
import SvgImage from "@/components/generic/SvgImage.vue"
export default {
  emits: ['close','submit'],
  components: {
    FormFieldComponent,
    ButtonComponent,
    SvgImage
  },
  props: {
    wizard: Object,
    formMethod: {
      type: String,
      default: 'GET'
    }
  },
  data() {
    return {
      activeStep: 0,
    }
  },
  methods: {
    wizardSkip(s) {
      this.activeStep += s;
    },
    onSubmit() {
      let form = this.$refs.form;
      if (this.wizard.propagate_submit) {
        this.$emit("submit", this.$refs.form);
      } else {
        formSubmit(this, form);
        this.$emit("close");
      }
    },
  }

}
</script>